import { render, staticRenderFns } from "./rescueService.vue?vue&type=template&id=b5c20b84&scoped=true"
import script from "./rescueService.vue?vue&type=script&lang=js"
export * from "./rescueService.vue?vue&type=script&lang=js"
import style0 from "./rescueService.vue?vue&type=style&index=0&id=b5c20b84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5c20b84",
  null
  
)

export default component.exports